/**
 * Table of per-return outcomes for a bulk RMA action request.
 */
import Table from '../../../../../../components/table/table';
import { IColumn } from '../../../../../../components/table/table.types';
import { IBulkRmaActionReturnRow } from '../../../../../../services/api/troubleshooting-service';
import ReturnTableRow from './return-table-row';

interface IReturnsTableProps {
    returns: IBulkRmaActionReturnRow[];
}

const RETURNS_COLUMNS: IColumn[] = [
    { content: 'RMA', width: { value: 88, type: 'px' } },
    { content: 'Outcome', width: { value: 110, type: 'px' } },
    { content: 'Reason', width: { value: 140, type: 'px' } },
    { content: 'Chunk', width: { value: 72, type: 'px' } },
    { content: 'Message', width: { value: 2, type: 'fr' } },
];

const ReturnsTable: React.FC<IReturnsTableProps> = ({ returns }) => (
    <div className="bulk-rma-actions-page__table-wrapper">
        <Table columns={RETURNS_COLUMNS}>
            {returns.map((row) => (
                <ReturnTableRow key={row.id} row={row} />
            ))}
        </Table>
    </div>
);

export default ReturnsTable;
